const enums = {
  //领用状态
  requestStateTxt(i18n) {
    return {
      // 已提交
      1: i18n.t('page.requestState1'),
      // 待拣货
      19: i18n.t('page.requestState19'),
      // 领用驳回
      21: i18n.t('page.approveFlow7'),
      // 拣货中
      200: i18n.t('page.requestState200'),
      // 已拣货待出库
      201: i18n.t('page.requestState201'),
      // 拣货失败
      210: i18n.t('page.requestState210'),
      // 已拣货待出库
      220: i18n.t('key12'),
      // 已出库待自取
      300: i18n.t('page.requestState300'),
      // 已出库待配送
      301: i18n.t('page.requestState301'),
      // 配送中
      400: i18n.t('page.requestState400'),
      // 已签收
      500: i18n.t('page.requestState500'),
    };
  },
  //领用状态
  requestState: {
    //审批拒绝
    refused: -1,
    //未提交
    uncommitted: 0,
    //已提交
    commited: 1,
    //待拣货
    picking: 19,
    //领用驳回
    requestReturn: 21,
    //拣货中
    inPicking: 200,
    //已拣货待出库
    waitingOutStock: 201,
    //拣货失败
    pickingFailed: 210,
    //出库异常
    outStockException: 220,
    //库管员驳回
    CoasterDismissal: 250,
    //已出库待自取
    outStockSeeking: 300,
    //已出库待配送
    outStockDelivering: 301,
    //配送中
    delivering: 400,
    //已签收
    delivered: 500,
    //退库驳回
    refusedReturn: 510,
    //报废驳回
    refusedScrap: 520,
  },
  //领用审批状态
  requestApproveState: {
    //审批拒绝
    refused: -1,
    //待审批
    approvalPending: 0,
    //审批中（1~18）
    inApproving: 1,
    //审批完成
    completeApproval: 19,
  },
  //库存状态
  bottleState: {
    //预入库
    preInStock: 100,
    //库中
    inStock: 200,
    //出库
    outStock: 300,
    //快速出入库
    quickOutStock: 301,
    //退库
    returnStock: 400,
    //报损
    break: 500,
    //报废
    scrap: 600,
  },
  requestsInfoType: {
    // 我的领用
    MyRequests: 'MyRequests',
    // 待审批
    ApprovalPending: 'ApprovalPending',
    // 已审批
    CompleteApproval: 'CompleteApproval',
    // 待出库
    WaitingOutStock: 'WaitingOutStock',
    // 已出库
    OutStock: 'OutStock',
    // 已签收
    Receiving: 'Receiving',
  },
  role: {
    //超级管理员
    ap: 'ALL_PERMISSION',
    //管理员
    mp: 'MANAGER_PERMISSION',
    //订单审批角色
    oa: 'ORDER_APPROVE_PERMISSION',
    //领用员
    rp: 'REQUEST_PERMISSION',
    //项目管理角色
    pmp: 'PROJECT_MANAGER_PERMISSION',
    //申购员
    pp: 'PURCHASE_PERMISSION',
    //库管员
    im: 'IN_MANAGER',
  },
  //登录日志
  loginEnum: {
    // 前台登录
    LoginType: 0,
    // 导入
    LoginStatus: 0,
    // 导入
    LogoutStatus: 1,
  },
  procurementScheduleStatus: {
    //待提交
    Uncommitted: 0,
    //已提交
    Committed: 10,
    //待处理
    Pending: 20,
    //已处理
    Processed: 30,
    //已下单
    Placed: 40,
    //已到货
    Arrived: 50,
  },
  errorMessage: {
    '未提供令牌或签名.': 'No token or signature provided.',
    '组织机构未在服务端登记或未被授权运用当前功能.': 'The organization is not registered or not authorized to use the current module.',
    '未授权或授权过期，请重新登录.': 'Unauthorized or expired, please login again.',
    '帐号异地登录，请重新登录.': 'The account is logged in at another place, please log in again.',
    '令牌未授权或授权过期，请重新登录.': 'The token is not authorized or the authorization expires, please log in again.',
    '登录客户端无法识别，验证失败.': 'Login client is not recognized and authentication failed.',
    '签名未被许可或已经失效.': 'The signature is not licensed or has expired.',
    '签名错误.': 'Signature error.',
  },
  requestStateCode: {
    delivered: 'R_STA_YQS_TXT',
  },
  //仓库存储类型
  warehouseStorageType: {
    // 通用
    General: '1',
    // 非管控类物资
    Uncontrolled: '2',
    // 其它危险品
    Dangerous: '3',
    // 剧毒品
    Toxic: '4',
    // 易制爆品
    Explosives: '5',
    // 易制毒品
    Pretoxic: '6',
    // 精神药品
    Psychotropic: '7',
    // 麻醉药品
    Narcotic: '8',
    // 放射性
    Radioactive: '9',
  },
  //管控类型
  controlType: ['Dangerous', 'Toxic', 'Explosives', 'Pretoxic', 'Psychotropic', 'Narcotic', 'Radioactive'],
  noOperation: {
    YES: 1,
    NO: 0,
  },
  grossWeightRequired: {
    YES: '1',
    NO: '0',
  },
  loginType: {
    Normal: 0, // 正常登录
    AD: 1, // 域控登录
    SSO: 2, // 单点登录
  },
  ShowStateCode: {
    /**
     * 已签收
     */
    YQS: 'R_STA_YQS_TXT',
    /**
     * 退库中
     * */
    TKZ: 'R_STA_TKZ_TXT',
    /**
     * 报废中
     *  */
    BFZ: 'R_STA_BFZ_TXT',
    /**
     * 待自取
     * */
    DZQ: 'R_STA_DZQ_TXT',
    /**
     * 退库驳回
     */
    TKBH: 'R_STA_TKBH_TXT',
    /**
     * 报废驳回
     */
    BFBH: 'R_STA_BFBH_TXT',
    /**
     * 待审批
     * */
    DSP: 'R_STA_DSP_TXT',
    /**
     * 审批已拒绝
     * */
    YJJ: 'R_STA_YJJ_TXT',
  },
};

export default enums;
